import { useState, useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useResetDashboardSettings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [executeSettingsReset, setExecuteSettingsReset] = useState(false);
  const [showResetIcon, setShowResetIcon] = useState(false);

  const settingsResetExecuted = useCallback(() => {
    setExecuteSettingsReset(false);
    setShowResetIcon(false);
  }, []);

  const resetSettingsHandle = () => {
    setExecuteSettingsReset(true);
    navigate(location.pathname, { replace: true });
  };

  const query = location.search;

  useEffect(() => {
    if (query) setShowResetIcon(true);
  }, [query, setShowResetIcon]);

  return {
    executeSettingsReset,
    settingsResetExecuted,
    showResetIcon,
    setShowResetIcon,
    resetSettingsHandle,
  };
};

export default useResetDashboardSettings;